module.exports = __webpack_public_path__ + "static/download.8604ab81fa82aaea4eb740094d101da4.svg";